module.exports = __webpack_public_path__ + "b36515821d789987d05d4869edbba6e5.jpg";